import { put } from 'redux-saga/effects';
import UsersActions from '../redux/UsersRedux';
import i18n from '../i18n';

export function* getUsers(api, { customerId, pageParams }) {
  try {
    const getUsersResponse = yield api.getUsers(customerId, pageParams);
    console.log('getUsersResponse:', getUsersResponse);
    if (getUsersResponse.ok) {
      yield put(
        UsersActions.getUsersRequestSuccess(getUsersResponse.data.content, getUsersResponse.data.totalElements)
      );
    } else {
      api.checkAuth(getUsersResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof getUsersResponse.problem !== 'undefined'
          ? getUsersResponse.problem
          : typeof getUsersResponse.data.error !== 'undefined'
          ? getUsersResponse.data.error
          : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(UsersActions.getUsersRequestFailure(error));
    }
  } catch (error) {
    console.log('error in Users saga', error);
    yield put(UsersActions.getUsersRequestFailure(error));
  }
}

export function* createUser(api, { userInfos, customerId, pageParams, url }) {
  try {
    const createUserResponse = yield api.createUser(userInfos, url);
    console.log('createUserResponse:', createUserResponse);
    const getUsersResponse = yield api.getUsers(customerId, pageParams);
    const successMessage = i18n.t('successMessage.createUserSuccess');
    console.log('getUsersResponse:', getUsersResponse);
    if (createUserResponse.ok && getUsersResponse.ok) {
      yield put(
        UsersActions.createUserRequestSuccess(
          createUserResponse.data.userId,
          createUserResponse.data.address.addressId,
          getUsersResponse.data.content,
          getUsersResponse.data.totalElements,
          successMessage
        )
      );
    } else {
      api.checkAuth(createUserResponse);
      api.checkAuth(getUsersResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof createUserResponse.problem !== 'undefined'
          ? createUserResponse.problem
          : typeof createUserResponse.data.error !== 'undefined'
          ? createUserResponse.data.error
          : null;
      if (errorBody) {
        let translatedError = i18n.t(`error.${errorBody}`);
        if (errorBody === 'CLIENT_ERROR') {
          translatedError = i18n.t('UserManager_updateUser_usernameAlreadyInUser_error2');
        }
        error += `: ${translatedError}`;
      }
      yield put(UsersActions.createUserRequestFailure(error));
    }
  } catch (error) {
    console.log('error in Users saga', error);
    yield put(UsersActions.createUserRequestFailure(error));
  }
}

export function* editUser(api, { userInfos, customerId, pageParams }) {
  console.log('userInfos:', userInfos);
  try {
    const editUserResponse = yield api.editUser(userInfos);
    console.log('editUserResponse:', editUserResponse);
    const getUsersResponse = yield api.getUsers(customerId, pageParams);
    const successMessage = i18n.t('successMessage.editUserSuccess');
    console.log('getUsersResponse:', getUsersResponse);
    if (editUserResponse.ok && getUsersResponse.ok) {
      yield put(
        UsersActions.editUserRequestSuccess(
          getUsersResponse.data.content,
          getUsersResponse.data.totalElements,
          successMessage
        )
      );
    } else {
      api.checkAuth(editUserResponse);
      api.checkAuth(getUsersResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof editUserResponse.problem !== 'undefined'
          ? editUserResponse.problem
          : typeof editUserResponse.data.error !== 'undefined'
          ? editUserResponse.data.error
          : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(UsersActions.editUserRequestFailure(error));
    }
  } catch (error) {
    console.log('error in Users saga', error);
    yield put(UsersActions.editUserRequestFailure(error));
  }
}

export function* deleteUser(api, { username, customerId, pageParams }) {
  try {
    const deleteUserResponse = yield api.deleteUser(username);
    console.log('deleteUserResponse:', deleteUserResponse);
    const getUsersResponse = yield api.getUsers(customerId, pageParams);
    const successMessage = i18n.t('successMessage.deleteUserSuccess');
    console.log('getUsersResponse:', getUsersResponse);
    if (deleteUserResponse.ok && getUsersResponse.ok) {
      yield put(
        UsersActions.deleteUserRequestSuccess(
          getUsersResponse.data.content,
          getUsersResponse.data.totalElements,
          successMessage
        )
      );
    } else {
      api.checkAuth(deleteUserResponse);
      api.checkAuth(getUsersResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof deleteUserResponse.problem !== 'undefined'
          ? deleteUserResponse.problem
          : typeof deleteUserResponse.data.error !== 'undefined'
          ? deleteUserResponse.data.error
          : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(UsersActions.deleteUserRequestFailure(error));
    }
  } catch (error) {
    console.log('error in Users saga', error);
    yield put(UsersActions.deleteUserRequestFailure(error));
  }
}
